import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';

export const errorCodeResolver: ResolveFn<number> = (route: ActivatedRouteSnapshot) => {
  if (route.queryParams?.statusCode) {
    return +route.queryParams.statusCode;
  } else {
    return 404;
  }
};